import { render, staticRenderFns } from "./PaymentErrorDetail.vue?vue&type=template&id=cd28da26"
import script from "./PaymentErrorDetail.vue?vue&type=script&lang=js"
export * from "./PaymentErrorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports